<template>
  <div class="emv">
    <div class="t_header" v-if="w_width<888">
      <div class="fx_cs t_topbar">
        <img src="../assets/img/homepage/logotop.png" style="height: 28px" />
        <i class="iconfont iconzu1714" style="color: #FFFFFF" @click="change()"></i>
      </div>
      <div class="t_maindiv1" style="height: 340px">
        <img src="../assets/img/bg/6.jpg" style="height: 340px">
        <div class="t_mes">
          <img src="../assets/img/25.png" style="width: 122px">
          <div class="t_title">
            <div>TMIP产品体系</div>
            <div>EMV 生产可视化</div>
            <div />
          </div>
        </div>
      </div>
    </div>
    <div class="header" v-else>
      <div class="topbar">
        <img src="../assets/img/homepage/logotop.png" />
        <myheader></myheader>
      </div>
      <div class="widtol mesdiv1">
        <div class="mesdiv2">
          <span class="messp1">TMIP产品体系</span>
          <span class="messp2">EMV 生产可视化</span>
        </div>
        <div class="mesdiv3">
          <img src="../assets/img/25.png" style="width: 283px; height: 276px" />
        </div>
      </div>
    </div>

    <div class="t_maindiv1" style="height: 150px" v-if="w_width<888">
      <img src="../assets/img/bg/2.jpg" style="height: 200px;">
      <div class="t_txt9">
        应用数据孪生技术，对生产过程进行镜像，核验工艺条件参数与设备实际生产参数的一致性， 按设定的阈值对结果进行比对、控制，多渠道触达相关人员，提升加工质量管理水平
      </div>
    </div>
    <div class="mesdiv4" v-else>
      <div class="widtol mesdiv5">
        <span class="messp3">EMV 生产可视化</span>
        <span class="messp4">
          应用数据孪生技术，对生产过程进行镜像，核验工艺条件参数与设备实际生产参数的一致性，<br>
           按设定的阈值对结果进行比对、控制，多渠道触达相关人员，提升加工质量管理水平。
          </span>
      </div>
    </div>

    <div v-if="w_width<888">
      <div class="t_mes_info">
        <div class="t_mes_txt">核心模块</div>
        <img src="../assets/img/17.png" style="width: 80%;margin-left: 10%">
        <div class="t_mes_txt2">现场作业无纸化，数据精确详细</div>
        <div class="t_mes_txt3">
          工艺参数直观展示，无纸化现场作业，减少人为的错误输入，实现生产数据与管理业务的无缝连接，减少管理人员的工作量
        </div>
      </div>
      <div class="t_mes_info" style="background: #FFFFFF">
        <img src="../assets/img/18.png" style="width: 100%;">
        <div class="t_mes_txt2">直观实时数据比对<br>问题发现更及时</div>
        <div class="t_mes_txt3">
          根据发现的异常原料信息自下而上追溯，追溯到所有拥到此原料批次的产品信息，可及时正确对潜在的问题产品进行处理，减少损失
        </div>
      </div>
      <div class="t_mes_info">
        <img src="../assets/img/19.png" style="width: 80%;margin-left: 10%">
        <div class="t_mes_txt2">生产数据及时掌握<br>安排更高效合理</div>
        <div class="t_mes_txt3">
          增加生产数据收集的及时性和准确性，为生产过程追溯提供了精确的数据支持，使生产计划更准确，提高产能
        </div>
      </div>
      <div class="t_mes_info" style="background: #FFFFFF">
        <img src="../assets/img/20.png" style="width: 100%;">
        <div class="t_mes_txt2">生产数据及时掌握<br>安排更高效合理</div>
        <div class="t_mes_txt3">
          增加生产数据收集的及时性和准确性，为生产过程追溯提供了精确的数据支持，使生产计划更准确，提高产能
        </div>
      </div>
    </div>
    <div class="mesdiv6" v-else>
      <span class="messp5">核心模块</span>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8 txt-left">
          <img src="../assets/img/17.png" style="width: 493px; height: 277px" />
        </div>
        <div class="mesdiv8">
          <div class="mesdiv9">
            <span class="messp6">现场作业无纸化，数据精确详细</span>
            <span class="messp7">工艺参数直观展示，无纸化现场作业，减少人为的错误输入，实现生产<br>
            数据与管理业务的无缝连接，减少管理人员的工作量</span>
          </div>
        </div>
      </div>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8">
          <div class="mesdiv9" style="margin-left: 60px; padding-left: 0px">
            <span class="messp6">直观实时数据比对，问题发现更及时</span>
            <span class="messp7">实时采集实际生产参数，比对标准工艺库设定的理论值，直观显示出当<br>
            前生产是否合规，加强了生产过程的质量控制</span>
          </div>
        </div>
        <div class="mesdiv8 txt-right">
          <img src="../assets/img/18.png" style="width: 523px; height: 304px" />
        </div>
      </div>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8 txt-left">
          <img src="../assets/img/19.png" style="width: 477px; height: 306px" />
        </div>
        <div class="mesdiv8">
          <div class="mesdiv9">
            <span class="messp6">生产数据及时掌握，安排更高效合理</span>
            <span class="messp7">增加生产数据收集的及时性和准确性，为生产过程追溯提供了精确的数据<br>
            支持，使生产计划更准确，提高产能。</span>
          </div>
        </div>
      </div>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8">
          <div class="mesdiv9" style="margin-left: 60px; padding-left: 0px">
            <span class="messp6">员工产量自动统计，员工管理更精确</span>
            <span class="messp7">自动记录工作人员工时，掌握员工的工作效率，增强对员工的管理。</span>
          </div>
        </div>
        <div class="mesdiv8 txt-right">
          <img src="../assets/img/20.png" style="width: 474px; height: 337px" />
        </div>
      </div>
    </div>
    <div v-if="w_width<888">
      <div class="t_emv" id="opc">
        <img src="../assets/img/1655.jpg" style="width: 100%;">
        <div class="t_emv_div">
          <div class="t_emv_txt">基于OPC的加工过程<br>监控案例</div>
          <img src="../assets/img/1656.png" style="width: 70.4%;margin-top: 30px">
        </div>
      </div>
      <div class="t_emv">
        <img src="../assets/img/73.png" style="width: 100%;">
        <div class="t_emv_div" style="top: 80px">
          <div class="t_emv_txt" style="color: #FFFFFF">定型机加工示意图</div>
        </div>
      </div>
      <div class="t_emv">
        <div style="width: 100%;overflow-x: auto;background: #565759;height: 845px;padding: 80px 0 140px 0" ref="scollElement">
          <img src="../assets/img/1797.png" style="height: 100%">
        </div>
        <div class="t_emv_txt" style="color: #FFFFFF;position: absolute;top: 40px;text-align: center;width: 100%">车间定位系统</div>
        <img src="../assets/img/167.png" style="position: absolute;bottom: 25px;width: 120%;transform: translateX(-10%);">
        <img src="../assets/img/1796.png" style="width: 50px;position: absolute;right: 20px;bottom: 220px">
      </div>
    </div>
    <div v-else>
      <div class="emvdiv1">
        项目案例
      </div>
      <div class="e_title">
        <div style="text-align: center;cursor: pointer;" @click="changePos(0)">
          基于OPC的加工过程监控<br>
          <div class="e_line" v-show="e_idnex==0"></div>
        </div>
        <div style="text-align: center;margin-left: 70px;cursor: pointer;" @click="changePos(1)">
          定型机加工场景<br>
          <div class="e_line" v-show="e_idnex==1"></div>
        </div>
        <div style="text-align: center;cursor: pointer;" @click="changePos(2)">
          车间定位系统（染色工厂示例）<br>
          <div class="e_line" v-show="e_idnex==2"></div>
        </div>
      </div>
      <el-carousel height="944px" :autoplay="false" @change="chose" ref="remarkCarusel">
        <el-carousel-item>
          <div style="position: relative;height: 100%">
            <img src="../assets/img/1480.png" style="width: 100%;min-width: 1440px">
            <img src="../assets/img/1481.png" style="position: absolute;height: 100%;top: 0;left: 10%">
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div style="position: relative;">
            <img src="../assets/img/1479.png" style="width: 100%;min-width: 1440px">
            <div style="position: absolute;top: 120px;left: 0;width: 100%;text-align: center;">
              <img src="../assets/img/1461.png">
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div style="background: #E0E9F2;text-align: center;height: 100%">
            <div style="display: inline-block;position: relative;">
              <img src="../assets/img/1478.png" style="width: 1366px;">
              <img src="../assets/img/169.png" style="position: absolute;top: 60px;right: 160px">
            </div>   
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!---首页弹出----->
    <mt-popup
      v-model="boxShow"
      position="right">
      <div style="display: block;padding: 40px 7%;" :style="{width:w_width+'px',height:w_height+'px'}">
        <div style="text-align: right">
          <span style="font-size: 25px" @click="boxShow=false">✕</span>
        </div>
        <div class="t_list" @click="goto('/#')">首页</div>
        <div class="t_list fx_cs" @click="listShow=true">
          TMIP产品体系
          <i class="iconfont iconlujing3278 t_icon2"></i>
        </div>
        <div v-show="listShow">
          <div class="t_t_list" @click="goto('/mes')">MES 生产管理</div>
          <div class="t_t_list" @click="goto('/wms')">WMS 智慧仓储</div>
          <div class="t_t_list" @click="goto('/mtr')">MTR 物料溯源</div>
          <div class="t_t_list" @click="boxShow=false">EMV 生产可视化</div>
        </div>
        <div class="t_list" @click="goto('/service')">服务与支持</div>
        <div class="t_list" style="border: 0" @click="goto('/aboutus')">关于我们</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import util from "../components/util";
import Swiper from "swiper";
export default util.useCommon({
  data() {
    return {
      w_width:0,
      boxShow: false,
      listShow:true,
      w_height:0,
      e_height:0,//项目案例高度
      e_idnex:0,
      s_height:0,//项目案例手机端
    };
  },
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  watch: {
  },
  methods: {
    change(){
      this.boxShow = true;
      console.log(this.boxShow);
    },
    goto(add) {
      this.backtop();
      this.$router.push(add);
    },
    backtop() {
      this.$emit('gotoTop');
    },
    chose(index){
      this.e_idnex = index;
    },
    changePos(index){
      this.e_idnex = index;
      this.$refs.remarkCarusel.setActiveItem(index);
    },
    getHeight(){
      
    }
  },
  mounted() {
    this.w_width = window.innerWidth;
    console.log(this.w_width);
    console.log(window.innerHeight);
    this.w_height = window.innerHeight;
    this.e_height = window.innerWidth/1440*943-11;
    this.s_height = window.innerWidth/375*845;
    this.$emit('getInfo',document.getElementById("opc").getBoundingClientRect().y,1);
    var that = this;
    setTimeout(function(){
      that.$refs.scollElement.scrollLeft = 400;
    },500)
  },
  activated() {
  }
});
</script>
<style scoped>
.header {
  background-image: url("../assets/img/bg/6.jpg");
  height: 520px;
}
.mesdiv4 {
  background-image: url("../assets/img/bg/2.jpg");
  height: 330px;
}
.mesdiv5 {
  padding-top: 90px;
}
.mesdiv6 {
  padding-bottom: 125px;
}
.messp7{
  line-height: 28px;
}
.emv{
  background-color: #fbfbfb;
}
.emvdiv1{
  text-align: center;
  font: normal normal normal 40px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
  padding-bottom: 50px;
}
.emvdiv2{
  height: 1032px;
  background-image: url("../assets/img/bg/7.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.emvdiv4{
  height: 100%;
}
.emvdiv3{
  height: 100%;
  width: 468px;
  opacity: 0.9;
  background-color: #24328B;
}
.emvdiv5{
  width: 100%;
  height: 100%;
  z-index: 999;
  padding: 141px 49px 59px 71px;
  position: relative;
}
.emvdiv5 img{
  width: 347px;
  height: 832px;
}
.emvsp1{
  position: absolute;
  top: 51px;
  left: 47px;
  font: normal normal normal 28px/32px Source Han Sans CN;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  line-height: 32px;
}
.emvdiv6{
  padding: 76px 0 38px;
  text-align: center;
  font: normal normal normal 34px/32px Source Han Sans CN;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
  line-height: 32px;
}
.emdiv7{
  padding-bottom: 86px;
}
.emdiv7 img{
  width: 1086px;
  height: 650px;
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
}
</style>
